interface PageHeroProps {
  title: string;
  subtitle?: string;
  badge?: string;
}

export const PageHero = ({ title, subtitle, badge }: PageHeroProps) => {
  return (
    <section className="bg-primary pt-52 md:pt-48 lg:pt-52 pb-16" aria-labelledby="page-hero-title">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl">
          {badge && (
            <span className="inline-block px-4 py-1.5 text-sm font-medium rounded-full border border-primary-foreground/30 text-primary-foreground/90 mb-4">
              {badge}
            </span>
          )}
          <h1 id="page-hero-title" className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-primary-foreground mb-4">
            {title}
          </h1>
          {subtitle && (
            <p className="text-lg md:text-xl text-primary-foreground/80">
              {subtitle}
            </p>
          )}
        </div>
      </div>
    </section>
  );
};
